import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

interface PolicyContent {
  title?: string;
  terms?: any;
  useLicense?: any;
  disclaimer?: any;
  limitations?: any;
  revisionsAndErrata?: any;
  links?: any;
  siteTermsOfUseModifications?: any;
  yourPrivacy?: any;
  governingLaw?: any;
}

@Component({
  selector: 'app-terms-of-service',
  templateUrl: './terms-of-service.component.html',
  styleUrls: ['./terms-of-service.component.scss']
})
export class TermsOfServiceComponent implements OnInit, OnDestroy {
  content: PolicyContent = {};
  private destroy$ = new Subject<void>();

  constructor(private translate: TranslateService) { }

  ngOnInit(): void {
    this.loadContent();
    // Reload content when language changes
    this.translate.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.loadContent());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadContent(): void {
    this.translate.get('policies.termsOfService')
      .pipe(takeUntil(this.destroy$))
      .subscribe(content => {
        this.content = content;
      });
  }

}
